/**
 * @generated SignedSource<<001d71facee0f9a2aac2683acdac845b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type WorkspaceTagsPageTagsQuery$variables = {};
export type WorkspaceTagsPageTagsQuery$data = {
  readonly account: {
    readonly id: string;
    readonly tags: ReadonlyArray<{
      readonly color: Colors;
      readonly createdBy: {
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly homePanelGroup: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly label: string;
      readonly lastChangedBy: {
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
    }>;
  };
  readonly user: {
    readonly id: string;
    readonly internalAttributes: {
      readonly isAccountAdmin: boolean;
    } | null;
  };
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_viewer">;
  };
};
export type WorkspaceTagsPageTagsQuery = {
  response: WorkspaceTagsPageTagsQuery$data;
  variables: WorkspaceTagsPageTagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountAdmin",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastChangedBy",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroup",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTagsPageTagsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HomePanelGroupsMenu_object"
              },
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomePanelGroupsMenu_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WorkspaceTagsPageTagsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelGroup",
                    "kind": "LinkedField",
                    "name": "homePanelGroup",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "NoteStream",
                    "abstractKey": null
                  }
                ],
                "type": "HomePanelObjectInterface",
                "abstractKey": "__isHomePanelObjectInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HomePanelGroup",
            "kind": "LinkedField",
            "name": "homePanelGroups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emojiName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f6112bc27389ee01af24a995a194c08",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTagsPageTagsQuery",
    "operationKind": "query",
    "text": "query WorkspaceTagsPageTagsQuery {\n  user {\n    id\n    internalAttributes {\n      isAccountAdmin\n      id\n    }\n  }\n  account {\n    id\n    tags {\n      ...HomePanelGroupsMenu_object\n      id\n      label\n      color\n      createdBy {\n        id\n        fullName\n      }\n      lastChangedBy {\n        id\n        fullName\n      }\n      homePanelGroup {\n        id\n      }\n    }\n  }\n  viewer {\n    ...HomePanelGroupsMenu_viewer\n    id\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment HomePanelGroupsMenu_viewer on Viewer {\n  homePanelGroups {\n    id\n    name\n    type\n    emojiName\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e0869d10593ff126d517830e097d212";

export default node;
